import { apiClient } from '~api/client';
import type { ArShapesQueryParams, ArShapesResponse } from './ar-shapes.types';

/**
 * AR Shapes service for fetching approval-to-release permit boundaries near a blast.
 */
const arShapesService = {
  /**
   * Get AR permit shapes for a given blast, filtered by mine site and permit type.
   * @param params - Query parameters for fetching AR shapes
   * @returns Promise resolving to AR shapes GeoJSON response
   */
  getArShapes: async (params: ArShapesQueryParams): Promise<ArShapesResponse> => {
    const { blast_name, mine_site, permit_type = 'blasting', crs = 'local' } = params;
    const response = await apiClient.get<ArShapesResponse>(`/ar_shapes/${encodeURIComponent(blast_name)}`, {
      params: { crs, mine_site, permit_type },
    });
    return response.data;
  },
};

export { arShapesService };
